import {certificateService, defaultService} from "../../services";
import {alertActions} from "../alert/alert.actions";
import {errorMessages} from "../../messages";
import {inboxConstants, sentConstants, uriConstants} from "../../constants";

export const inboxActions = {
  changeSearchInfo,
  readInboxList,
  readOrgInboxList,
  deleteInboxList,
  selectInboxInfo,
  openReceiverBox,
  addReceiverInfo,
  getRecentReceiver,
  changeFileRow,
  getInboxInfo,
  getPcrlInfo,
  getCrtfInfo,
  createCrtfSubmit,
  getWalletAddr,
  settingHistory,
  rejectInbox,
  getPdfString,
  initPdfFlag,
  getWalletName,
  resetWalletList,
  onClear,
  getFile,
  subInboxDocPdf,
  receiveInbox,
}

/*******************
 method 반드시 이렇게..

 GET    = Read
 POST   = Create
 PUT    = Update
 DELETE = Delete
 ********************/

/*********
 수신함 검색조건 변경
 **********/
function changeSearchInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: inboxConstants.SELECT_SEARCH_REQUEST,
      payload: info
    }
  }
}

/*********
 수신함 리스트 조회
 **********/

function readInboxList(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_INBOX_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: inboxConstants.INBOX_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.INBOX_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.INBOX_FAILURE,
      response
    }
  }
}

/*********
 수신함 원본 리스트 조회
 **********/

function readOrgInboxList(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_INBOX_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: inboxConstants.INBOX_ORG_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.INBOX_ORG_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.INBOX_ORG_FAILURE,
      response
    }
  }
}

/*********
 수신함 발급완료건 삭제
 **********/

function deleteInboxList(params) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'put',
      endPoint: uriConstants.API_URI + uriConstants.SET_INBOX_INFO,
      params: params,
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: inboxConstants.DELETE_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.DELETE_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.DELETE_FAILURE,
      response
    }
  }
}

/***********
 수신함 증명서 상세 선택
 ************/
function selectInboxInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: inboxConstants.SELECT_REQUEST,
      payload: info
    }
  }
}

/***********
 증명서 제출 수신자 SELECT 팝업 오픈
 ************/
function openReceiverBox(target) {
  return async dispatch => {
    dispatch(request(target))
  }
  function request() {
    return {
      type: inboxConstants.OPEN_RECEIVER_REQUEST,
      payload: target
    }
  }
}

/***********
 증명서 제출 수신자 추가
 ************/
function addReceiverInfo(receiver) {
  return async dispatch => {
    dispatch(request(receiver))
  }
  function request() {
    return {
      type: inboxConstants.ADD_RECEIVER_REQUEST,
      payload: receiver
    }
  }
}

/***********
 증명서 제출 전자지갑 리스트 초기화
 ************/
function resetWalletList() {
  return async dispatch => {
    dispatch(request())
  }
  function request() {
    return {
      type: inboxConstants.RESET_RECEIVER,
      payload: null
    }
  }
}

/*********
 최근 보낸 주소 조회
 **********/

function getRecentReceiver(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_RECENT_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: inboxConstants.SELECT_RECENT_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.SELECT_RECENT_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.SELECT_RECENT_FAILURE,
      response
    }
  }
}

/***********
 증명서 제출 첨부문서 row 최신화
 ************/
function changeFileRow(fileList) {
  return async dispatch => {
    dispatch(request(fileList))
  }

  function request() {
    return {
      type: inboxConstants.CHANGE_FILE_REQUEST,
      payload: fileList
    }
  }
}

/*********
 수신함 증명서 상세조회
 **********/

function getInboxInfo(crtSeq) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_INBOX_INFO + "/" + crtSeq
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: inboxConstants.DETAIL_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.DETAIL_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.DETAIL_FAILURE,
      response
    }
  }
}

/*********
 수신함 구매확인서 조회
 **********/

function getPcrlInfo(crtSeq) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_PRCL_INFO + "/" + crtSeq
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: inboxConstants.PCRL_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.PCRL_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.PCRL_FAILURE,
      response
    }
  }
}

/*********
 수신함 간접수출실적증명서 조회
 **********/

function getCrtfInfo(crtSeq) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_CRTF_INFO + "/" + crtSeq
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: inboxConstants.CRTF_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.CRTF_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.CRTF_FAILURE,
      response
    }
  }
}

/*********
 수신함 증명서 제출
 **********/
function createCrtfSubmit(params) {
  return async dispatch => {
    dispatch(request())
    certificateService.createCrtfSubmit(params)
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: inboxConstants.SUBMIT_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.SUBMIT_SUCCESS,
      response
    }
  }
  function failure(response) {
    console.log(response);
    return {
      type: inboxConstants.SUBMIT_FAILURE,
      response
    }
  }
}

/*********
 수신함 증명서 반려
 **********/
function rejectInbox(params) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'put',
      endPoint: uriConstants.API_URI + uriConstants.REJECT_CERTIFICATE,
      params: params
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }
  function request() {
    return {
      type: inboxConstants.REJECT_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.REJECT_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.REJECT_FAILURE,
      response
    }
  }
}

/*********
 수신함 증명서제출 전자지갑주소검색
 **********/
function getWalletAddr(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_WALLET_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: inboxConstants.WALLET_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.WALLET_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.WALLET_FAILURE,
      response
    }
  }
}

/*********
 수신함 증명서제출 전자지갑이름검색
 **********/
function getWalletName(params) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_WALLET_LIST + "/" + params
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: inboxConstants.WALLET_NAME_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.WALLET_NAME_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.WALLET_NAME_FAILURE,
      response
    }
  }
}

/***********
 증명서 수신함 리스트 히스토리관리
 ************/
function settingHistory(history) {
  return async dispatch => {
    dispatch(request(history))
  }

  function request(history) {
    return {
      type: inboxConstants.INBOX_HISTORY,
      payload: history
    }
  }
}

/***********
 증명서 PDF BASE64STRING 조회
 ************/
function getPdfString(fileId) {
  return async dispatch => {
    dispatch(request(fileId))

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_PDF_INFO + "/" + fileId
      // endPoint: "http://192.168.0.9:8080/portal/pdf/107"
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: inboxConstants.PDF_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.PDF_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.PDF_FAILURE,
      response
    }
  }
}

/***********
 PDF 호출 init 처리
 ************/
function initPdfFlag() {
  return async dispatch => {
    dispatch(request())
  }

  function request() {
    return {
      type: inboxConstants.INIT_FLAG_REQUEST,
    }
  }
}

/***********
 상태관련 state 초기화
 ************/
function onClear() {
  return async dispatch => {
    dispatch(request())
  }

  function request() {
    return {
      type: inboxConstants.CLEAR_REQUEST,
    }
  }
}

function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
  })
}

/***********
 증명서 첨부파일 다운로드
 ************/
function getFile(fileId) {
  return async dispatch => {
    dispatch(request(fileId))

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_FILE + "/" + fileId
      // endPoint: "http://192.168.0.9:8080/portal/pdf/107"
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(apiError(error))
        }
      )
  }

  function request() {
    return {
      type: inboxConstants.FILE_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.FILE_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.FILE_FAILURE,
      response
    }
  }
}

/*********
 수신함 PDF 발급요청
 **********/

function subInboxDocPdf(crtSeq) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'post',
      endPoint: uriConstants.API_URI + uriConstants.SUB_SENT_DOC_PDF,
      params: 'crtSeq='+ crtSeq
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(apiError(error))
            }
        )
  }

  function request() {
    return {
      type: inboxConstants.SUB_SENT_DOC_PDF_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.SUB_SENT_DOC_PDF_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.SUB_SENT_DOC_PDF_FAILURE,
      response
    }
  }
}

/*********
 수신함 증명서 수취완료
 **********/
function receiveInbox(params) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'put',
      endPoint: uriConstants.API_URI + uriConstants.RECEIVE_CERTIFICATE,
      params: params
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(apiError(error))
            }
        )
  }
  function request() {
    return {
      type: inboxConstants.RECEIVE_REQUEST
    }
  }
  function success(response) {
    return {
      type: inboxConstants.RECEIVE_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: inboxConstants.RECEIVE_FAILURE,
      response
    }
  }
}